import { useState } from 'react';
import { IP_PATTERN } from '@silverfort-nodelibs/common/utils/consts';

const MAX_FILE_SIZE_BYTES = 1_000_000;
const MAX_IPS_DEFAULT = 1000;

interface UseImportIpsFromCsvOptions {
    maxIps?: number;
}

export const useImportIpsFromCsv = ({ maxIps = MAX_IPS_DEFAULT }: UseImportIpsFromCsvOptions = {}) => {
    const [isLoading, setIsLoading] = useState(false);

    const importIpsFromCsv = async (file: File): Promise<string[]> => {
        if (file.size > MAX_FILE_SIZE_BYTES) {
            throw new Error('File exceeds maximum size of 1 MB');
        }

        setIsLoading(true);
        try {
            const content = await file.text();
            const validIps: string[] = [];

            for (const entry of content.split(',')) {
                if (validIps.length >= maxIps) break;
                const trimmed = entry.trim();
                if (IP_PATTERN.test(trimmed)) {
                    validIps.push(trimmed);
                }
            }

            return validIps;
        } finally {
            setIsLoading(false);
        }
    };

    return { importIpsFromCsv, isLoading };
};

